interface SectionHeaderProps {
  eyebrow?: string
  headline: string
  subheadline?: string
  centered?: boolean
  light?: boolean
}

export default function SectionHeader({
  eyebrow,
  headline,
  subheadline,
  centered = true,
  light = false,
}: SectionHeaderProps) {
  return (
    <div className={`mb-12 ${centered ? 'text-center' : ''}`}>
      {eyebrow && (
        <p
          className={`text-xs font-round font-bold tracking-[0.15em] uppercase mb-3 ${
            light ? 'text-brand-amber' : 'text-brand-blue'
          }`}
        >
          {eyebrow}
        </p>
      )}
      <h2
        className={`text-3xl md:text-4xl lg:text-5xl font-display font-bold leading-tight ${
          light ? 'text-white' : 'text-brand-navy'
        }`}
      >
        {headline}
      </h2>
      {subheadline && (
        <p
          className={`mt-4 text-lg leading-relaxed max-w-2xl ${
            centered ? 'mx-auto' : ''
          } ${light ? 'text-slate-200' : 'text-slate-500'}`}
        >
          {subheadline}
        </p>
      )}
    </div>
  )
}
